export default __webpack_public_path__ + "static/media/price-five-bg.53cd6439.png";